export default {
    title: 'User Feedbacks',
    feedbackList: 'Feedback list',
    areYouSureResolveFeedbacks: 'Are you sure you want to resolve selected feedbacks?',
    areYouSureResolveFeedback: 'Are you sure you want to resolve the feedback?',
};
